export default __webpack_public_path__ + "static/media/smsmarketing@3x.92589662.png";